import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reviews-link__number-of-reviews" }

import useWebsiteTexts from '@/composables/useWebsiteTexts';

import ReviewStars from './ReviewStars.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewsLink',
  props: {
  rating: {
    type: Number,
    default: 5,
  },
  totalReviews: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {



const { websiteText } = useWebsiteTexts();

function scrollToReviews() {
  const element = document.querySelector('.reviews');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "reviews-link",
    onClick: scrollToReviews
  }, [
    _createVNode(ReviewStars, { rating: __props.rating }, null, 8, ["rating"]),
    _createElementVNode("span", _hoisted_1, " (" + _toDisplayString(__props.totalReviews) + " " + _toDisplayString(_unref(websiteText)('review_reviews').value) + ") ", 1)
  ]))
}
}

})